module.exports = __webpack_public_path__ + "static/img/icon_tiktok.a9b17f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_tiktok.png
// module id = kPU3
// module chunks = 0